var React = require('react');

function Folder (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M464 128H272l-64-64H48C21.49 64 0 85.49 0 112v288c0 26.51 21.49 48 48 48h416c26.51 0 48-21.49 48-48V176c0-26.51-21.49-48-48-48z","className":"fa-secondary","key":1})]);
}

Folder.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Folder;

Folder.default = Folder;
